<template>
    <chat v-if="user && user.approved" :user="user" />
    <h1 v-else>{{ $t('master.unapprovedUser') }}</h1>
</template>

<script>
import Chat from '@/components/Chat.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'messages',
    components: { Chat },
    computed: mapGetters(['user'])
}
</script>
